<template>
    <div>
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Signing In..</p>
            </div>
        </transition>

        <!------------------------------------------------------>
        <!----------- Navbar when not logged in ---------------->
        <!------------------------------------------------------>
        <div v-if="!currentUser">
            <b-navbar type="light"  toggleable="lg" style="background-color:#87C3DF" >
                <b-navbar-brand ><router-link to="/login"><img  width="180px"  class="d-inline-block align-top" alt="Keg Seeker" src="../assets/KegSeeker_logo-KSwName-transparent.png"/></router-link>
                </b-navbar-brand>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-text  v-if="!currentUser"><router-link to="/createaccount" class="navheader2" ><font-awesome-icon icon="user-plus" />  Join</router-link></b-nav-text> 
                    <b-nav-form>
                        <!-- Email -->
                        <b-form-input size="sm" style="margin-left:5px; margin-right:5px" type="email"  v-model.trim="loginForm.email" class="my-2 my-sm-0" placeholder="Email"></b-form-input>
                        <!-- Password -->
                        <b-form-input size="sm" style="margin-left:5px;margin-right:5px" type="password" v-model="loginForm.password" class="my-2 my-sm-0" placeholder="Password"></b-form-input>
                        <!-- Login button -->
                        <b-button size="sm" class="my-2 my-sm-0" variant="outline-dark"  @click="login">Login</b-button>
                        <!-- Forgot Password -->
                        <div style="color:black; margin-left:5px">
                            <small><a @click="goToPasswordReset">Forgot Password?</a></small>
                        </div>

                    </b-nav-form>
                </b-navbar-nav>
            </b-navbar>

            <!-- Auth Error Modal -->
            <b-modal no-fade size="l" id="modal-autherror" ok-only title="Login Error" ok-title="OK">
                <div style="color:red">
                    {{errorMsg}}
                </div>   
                <!-- Forgot Password -->
                <div style="color:black; margin-left:5px; margin-top:10px">
                    <small><a @click="goToPasswordReset">Forgot Password?</a></small>
                </div>
            </b-modal>
            
        </div>
        <!------------------------------------------------------>
        <!----------- END Navbar when not logged in ------------>
        <!------------------------------------------------------>

        <!------------------------------------------------------>
        <!----------- Navbar for buyer -------- ---------------->
        <!------------------------------------------------------>
        <b-navbar v-if="currentUser&&userProfile.isbrewer<=0" toggleable="lg" type="dark"  style="background-color:#2e5189" >
            <b-navbar-brand ><router-link to="/login"><img  width="150px" src="../assets/KegSeeker_logo-horizontal-WHITE.png"/></router-link>
            </b-navbar-brand>
            

            <!-- Navbar collapse toggle  button -->
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            
            <!-- Nav bar -->
            <b-navbar-nav class="ml-auto ">                

                <!-- Cart for retailers -->
                <b-nav-item><router-link to="cart" class="navheader2" ><font-awesome-icon icon="shopping-cart" /> 
                        Cart <b-badge  variant="light" v-if='cartCount'>{{cartCount}}</b-badge></router-link>
                </b-nav-item>
            
                <!-- Collapsable nav bar -->
                

                <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                        <b-nav-item ><router-link to="/allbeers" class="navheader2" ><font-awesome-icon icon="beer" /> Find Beers</router-link></b-nav-item>
                        <b-nav-item ><router-link to="messagesholder" class="navheader2" ><font-awesome-icon icon="comment" /> Messages <b-badge  variant="light" v-if='unreadCount'>{{unreadCount}}</b-badge></router-link></b-nav-item>
                        <b-nav-item v-if="userProfile.isbrewer==0"><router-link to="customerorders" class="navheader2" ><font-awesome-icon icon="list-ul" /> Orders</router-link></b-nav-item>
                        <b-nav-item v-if="userProfile.isbrewer==-1"><router-link to="consumerorders" class="navheader2" ><font-awesome-icon icon="list-ul" /> Orders</router-link></b-nav-item>
                        <!--Invoices -->
                        <b-nav-item ><router-link to="buyerinvoices" class="navheader2" >Invoices</router-link></b-nav-item>

                        <b-nav-item-dropdown  right>
                            <!-- Using 'button-content' slot -->
                            <template v-slot:button-content>
                                <font-awesome-icon icon="user" />
                            </template>
                            <b-dropdown-item   tag="router-link" :to="{ path: '/settings' }"><font-awesome-icon icon="cog" /> Settings</b-dropdown-item>

                            <!--<b-dropdown-item   tag="router-link" :to="{ path: '/buyerservicerequests' }"><font-awesome-icon icon="cog" /> Service Requests</b-dropdown-item>-->
                            <b-dropdown-item @click="logout" ><font-awesome-icon icon="sign-out-alt" /> Sign Out</b-dropdown-item>
                            <b-dropdown-item   tag="router-link" :to="{ path: '/contact' }"><font-awesome-icon icon="question" /> Help</b-dropdown-item>
                        </b-nav-item-dropdown>
                    
                </b-collapse>
            </b-navbar-nav>
        </b-navbar>

        <!------------------------------------------------------>
        <!----------- END Navbar for buyer --------------------->
        <!------------------------------------------------------>

        <!------------------------------------------------------>
        <!----------- Navbar for brewery ----------------------->
        <!------------------------------------------------------>
        <b-modal no-fade size="l" id="modal-sharelink" ok-only title="Share this link to your profile and inventory" ok-title="OK">
            https://kegseeker.com/#/brewers/{{userProfile.shortName}} 
        </b-modal>

        <b-navbar  v-if="currentUser&&userProfile.isbrewer==1" toggleable="lg" type="dark"  style="background-color:#2e5189">
            <b-navbar-brand ><router-link to="brewerdashboard"><img  width="250px" src="../assets/KegSeeker_logo-horizontal-WHITE.png"/></router-link></b-navbar-brand>

            <b-navbar-toggle target="nav-collapse" ></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto navheader" >

                <b-nav-item><router-link to="/brewerdashboard" class="navheader2" ><font-awesome-icon icon="home" /> Dashboard</router-link></b-nav-item>
                
                <b-nav-item><router-link to="/messagesholder" class="navheader2" ><font-awesome-icon icon="comment" /> Messages <b-badge  variant="light" v-if='unreadCount'>{{unreadCount}}</b-badge></router-link></b-nav-item>
                <b-nav-item><router-link to="/brewerorders" class="navheader2" ><font-awesome-icon icon="list-ul" /> Orders <b-badge variant="light" v-if='newBreweryOrdersCount'>{{newBreweryOrdersCount}}</b-badge></router-link></b-nav-item>
                <b-nav-item><router-link to="/sellerservicerequests" class="navheader2" ><font-awesome-icon icon="shuttle-van" /> Service Requests <b-badge variant="light" v-if='openServiceRequests'>{{openServiceRequests}}</b-badge></router-link></b-nav-item>
                <b-nav-item><router-link to="/brewerinvoices" class="navheader2" ><font-awesome-icon icon="dollar-sign" /> Invoices</router-link></b-nav-item>
                <b-nav-item v-if="userProfile.isbrewer==1"><router-link to="inventory" class="navheader2" ><font-awesome-icon icon="warehouse" /> Inventory</router-link></b-nav-item>
                <b-nav-item v-if="userProfile.isbrewer==2"><router-link to="distributorinventory" class="navheader2" ><font-awesome-icon icon="warehouse" /> Inventory</router-link></b-nav-item>
                <b-nav-item-dropdown right>
                <!-- Using 'button-content' slot -->
                <template v-slot:button-content>
                    <font-awesome-icon icon="user" />
                </template>
                <b-dropdown-item v-if="userProfile.isbrewer==1||userProfile.isbrewer==2||userProfile.isbrewer==10"  tag="router-link" :to="{ path: '/managereps' }"><font-awesome-icon icon="user-friends" /> Manage Reps</b-dropdown-item>
                <b-dropdown-item  tag="router-link" :to="{ path: '/marketing' }"><font-awesome-icon icon="chart-line" /> Marketing Tools</b-dropdown-item>
                <b-dropdown-item  tag="router-link" :to="{ path: '/salesreport' }"><font-awesome-icon icon="chart-line" /> Sales Report</b-dropdown-item>
                <b-dropdown-item   tag="router-link" :to="{ path: '/settings' }"><font-awesome-icon icon="cog" /> Settings</b-dropdown-item>
                
                <b-dropdown-item @click="logout" ><font-awesome-icon icon="sign-out-alt" /> Sign Out</b-dropdown-item>
                <b-dropdown-item   tag="router-link" :to="{ path: '/contact' }"><font-awesome-icon icon="question" /> Help</b-dropdown-item>
                </b-nav-item-dropdown>

            </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <!------------------------------------------------------>
        <!----------- END Navbar for brewery ------------------->
        <!------------------------------------------------------>


        <!------------------------------------------------------>
        <!----------- Navbar for reps ------------------->
        <!------------------------------------------------------>

    <b-navbar v-if="currentUser&&userProfile.isbrewer == '10'" toggleable="lg" type="dark"  style="background-color:#2e5189">
        <b-navbar-brand ><router-link to="brewerdashboard"><img  width="250px" src="../assets/KegSeeker_logo-horizontal-WHITE.png"/></router-link></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto navheader">
            <b-nav-item ><router-link to="/brewerdashboard" class="navheader2" ><font-awesome-icon icon="home" /> Dashboard</router-link></b-nav-item>
            
            <b-nav-item ><router-link to="/messagesholder" class="navheader2" ><font-awesome-icon icon="comment" /> Messages <b-badge  variant="light" v-if='unreadCount'>{{unreadCount}}</b-badge></router-link></b-nav-item>
            <b-nav-item ><router-link to="/brewerorders" class="navheader2" ><font-awesome-icon icon="list-ul" /> Orders <b-badge variant="light" v-if='newBreweryOrdersCount'>{{newBreweryOrdersCount}}</b-badge></router-link></b-nav-item>
            <b-nav-item v-if="currentUser"><router-link to="/brewerinvoices" class="navheader2" ><font-awesome-icon icon="dollar-sign" /> Invoices</router-link></b-nav-item>
            <b-nav-item v-if="userProfile.isbrewer==1||userProfile.isbrewer==10"><router-link to="inventory" class="navheader2" ><font-awesome-icon icon="warehouse" /> Inventory</router-link></b-nav-item>
            <b-nav-item v-if="userProfile.isbrewer==2"><router-link to="distributorinventory" class="navheader2" ><font-awesome-icon icon="warehouse" /> Inventory</router-link></b-nav-item>
            <b-nav-item-dropdown  v-if="currentUser" right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
                <font-awesome-icon icon="user" />
            </template>
            <b-dropdown-item  tag="router-link" :to="{ path: '/salesreport' }"><font-awesome-icon icon="chart-line" /> Sales Report</b-dropdown-item>
            <b-dropdown-item   tag="router-link" :to="{ path: '/settings' }"><font-awesome-icon icon="cog" /> Settings</b-dropdown-item>
            <b-dropdown-item @click="showModalForLink" ><font-awesome-icon icon="share" /> Share A Link To Your Inventory</b-dropdown-item>
            
            
            <b-dropdown-item  v-b-tooltip.hover title="Share Your Inventory on you Facebook timeline">
                <social-sharing :url="'https://kegseeker.com/#/brewers/' +userProfile.shortName"
                                title="Check out our inventory on Kegseeker.com"
                                description="See and order our latest beers on Kegseeker.com"
                                quote="Check out our inventory on Kegseeker.com"
                                inline-template>
                    <div>

                        <network network="facebook"   >
                            <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }"/> Share on Facebook
                        </network>
                    </div>
                    </social-sharing>
                </b-dropdown-item>
            
            <b-dropdown-item @click="logout" ><font-awesome-icon icon="sign-out-alt" /> Sign Out</b-dropdown-item>
            <b-dropdown-item   tag="router-link" :to="{ path: '/contact' }"><font-awesome-icon icon="question" /> Help</b-dropdown-item>
            </b-nav-item-dropdown>

        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
  <!------------------------------------------------------>
        <!----------- END Navbar for reps ---------------------->
        <!------------------------------------------------------>


    </div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import Pagefooter from './Pagefooter'
    export default {
        components: {
            Pagefooter,
            },

        computed: {
            ...mapState(['userProfile', 'cartCount', 'unreadCount', 'currentUser', 'userAddressFromIP', 'consumerCartCount', 'allowConsumers', 'openServiceRequests', 'newBreweryOrdersCount']),
        },
        data() {
            return {
                windowWidth:0,
                loginForm: {
                    email: '',
                    password: ''
                },
                performingRequest:false,
                errorMsg:"",
            }
        },
        methods: {
            logout() {
                fb.auth.signOut().then(() => {
                    this.$store.dispatch('clearData')
                    this.$router.push('/login')
                }).catch(err => {
                    console.log(err)
                })
            },

            //Go to consumer site
            goToConsumerSite(){
                window.open("https://consumer.kegseeker.com", "_blank");
            },

            //Create account form
            goToCreateAccount() {
                this.$router.push({name:'createaccount'})
                this.errorMsg = ''
                //this.showLoginForm = !this.showLoginForm
                
            },

            //Go to password reset
            goToPasswordReset(){
                this.$bvModal.hide("modal-autherror")
                this.$router.push({path:'/forgotpassword'})
            },

            //Login
            login() {
                this.performingRequest = true
                this.$store.commit('setUserProfileStatus',0)

                fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
                    this.$store.commit('setCurrentUser', user.user)
                    this.theUserID = user.user.uid
                    this.performingRequest = false
                    this.$router.push({path:'/login'})
                        
                }).catch(err => {
                    console.log(err)
                    this.performingRequest = false
                    this.errorMsg = err.message
                    this.$bvModal.show("modal-autherror")
                })
            },
        },
        mounted(){

        }
    }
</script>
<style scoped>

.wrapper {
  position: sticky;
  top: 0;
}
</style>